import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const EyeOff: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7819 11.7667C13.7982 10.4844 15.1504 8.44077 15.1504 7.67619C15.1504 6.52932 12.0943 2.48795 8.32379 2.48795C6.7422 2.48795 5.28512 3.2001 4.12732 4.11105"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.59519 12.7137C9.17862 12.8128 8.75199 12.8633 8.3238 12.8644C4.55331 12.8644 1.49716 8.82305 1.49716 7.67618C1.49716 7.28078 1.85979 6.5435 2.48894 5.74506"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33331 0.685699C6.13599 6.83732 9.03158 9.70014 15.3143 14.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.32822 6.63087C6.63951 5.8925 7.32545 5.49164 8.32378 5.49164C9.72188 5.49164 10.5083 6.27807 10.5083 7.67616C10.5083 8.67012 10.1107 9.35388 9.38 9.66736"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
